import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledCommonInput = styled('div')`
  width: 100%;
  .input-field {
    .MuiOutlinedInput-root {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      letter-spacing: -0.4px;
      border-radius: 8px;
      color: ${COLOR.darkGray};
      /* Hide scrollbar but allow scroll */
      overflow: auto;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
    }
    .MuiOutlinedInput-root::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
    textarea {
      overflow: auto !important;
      resize: none;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
    }
    textarea::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }
  /* this to remove background color for Textfield when autofill */
  input:-webkit-autofill,
  input:-webkit-autofill:focus {
    transition: background-color 0s 600000s, color 0s 600000s !important;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
  .input-error {
    color: ${COLOR.functionalRed.default};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
  }
`;
